import { switchMap, withLatestFrom, map } from 'rxjs/operators';
import { BidHistoryActionEnum, IFetchSubmissionHistoryAction } from '.';
import { BidService, ISubmissionHistoryItems } from '../../services';
import { ofType } from 'redux-observable';
import { FetchedSubmissionHistorySuccessfully } from './ActionCreator';
import { IApplicationState } from '..';

const bidService = new BidService();

export const retrieveHistoryEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(BidHistoryActionEnum.FetchSubmissionHistory),
    withLatestFrom(state$),
    switchMap(
      ([action, state]: [IFetchSubmissionHistoryAction, IApplicationState]) => {
        const response = bidService.getSubmissionHistoryByDocumentId(
          action.state?.submissionHistory?.documentId
        );
        return response;
      }
    ),
    map((x: ISubmissionHistoryItems[]) => {
      return FetchedSubmissionHistorySuccessfully(x);
    })
  );
